// extracted by mini-css-extract-plugin
export default {"serviceTitle":"ServiceTwo_serviceTitle__a3kVb","bestService":"ServiceTwo_bestService__Mt92x","icon":"ServiceTwo_icon__3+2Go","content":"ServiceTwo_content__YeoZv"};